// Checkout Page V2 - WIP.
// Lot's to still implement here
// - Pricing/Booking integration
// - Payments integration
// - Better form state management -> redux?

/* eslint-disable */

import React, { Component } from 'react';

import creditCardType from 'credit-card-type';
import NumberFormat from 'react-number-format';

import ReactFlagsSelect from 'react-flags-select';

import Summary from 'views/plugins/gift_certificates/summary/Summary';

import './Checkout.scss';

class Checkout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {},
      errors: {},
      deliveryChoice: 'you',
      recipientMessageExpanded: false,
      submitLoading: false,
    };
  }

  setDeliveryChoice = (choice) => {
    this.setState({
      deliveryChoice: choice,
    });
  };

  updateFormState = (key, event) => {
    // Extracting value out of event due to <NumberFormat />
    let value = '';
    if (typeof event.value !== 'undefined') {
      if (event.value.length > 0) {
        value = event.value;
      }
    } else {
      value = event.target.value;
    }

    const newFormState = { ...this.state.form };
    newFormState[key] = value;

    // Billing autopopulate
    if (key === 'guestFirstName') newFormState.paymentFirstName = value;
    if (key === 'guestLastName') newFormState.paymentLastName = value;

    this.setState({ form: newFormState });
  };

  formValid = () => {
    // Basic presence check for form values
    let requiredValues = ['guestFirstName', 'guestLastName', 'guestEmail'];
    const recipientValues = [
      'recipientFirstName',
      'recipientLastName',
      'recipientEmail',
    ];

    if (this.state.deliveryChoice === 'other') {
      requiredValues = [...requiredValues, ...recipientValues];
    }

    let formValid = true;
    for (let i = 0; i < requiredValues.length; i++) {
      const value = this.state.form[requiredValues[i]];
      if (!value || value.length === 0) {
        formValid = false;
        break;
      }
    }

    return formValid;
  };

  submitCheckout = () => {
    const { deliveryChoice } = this.state;

    if (this.formValid()) {
      this.setState({ submitLoading: true });

      setTimeout(() => {
        if (deliveryChoice === 'you') {
          // Copy over existing form values
          const newFormState = { ...this.state.form };
          newFormState.recipientFirstName = newFormState.guestFirstName;
          newFormState.recipientLastName = newFormState.guestLastName;
          newFormState.recipientEmail = newFormState.guestEmail;
          this.setState({
            deliveryChoice: 'you',
            form: newFormState,
          });
          this.props.submitCheckout(newFormState);
        } else {
          this.props.submitCheckout(this.state.form);
        }
        this.props.history.push(
          `/${this.props.match.params.guide_slug}/gift_certificates/confirmation`
        );
        this.setState({ submitLoading: false });
      }, 1000);
    } else {
      const { form } = this.state;
      const requiredValues = [
        'guestFirstName',
        'guestLastName',
        'guestEmail',
        'recipientFirstName',
        'recipientLastName',
        'recipientEmail',
      ];

      const errors = {};
      for (let i = 0; i < requiredValues.length; i++) {
        const value = form[requiredValues[i]];
        if (!value || value.length === 0) {
          errors[requiredValues[i]] = true;
        }
      }

      this.setState({ errors });
      window.scrollTo(0, 0);
    }
  };

  determineCardType = () => {
    const { paymentCardNumber } = this.state.form;
    if (paymentCardNumber && paymentCardNumber.length > 0) {
      const types = creditCardType(this.state.form.paymentCardNumber);
      if (types.length > 0) return types[0].type;
    }
    return 'none';
  };

  renderGuestDetails = () => {
    return (
      <div className="formSection">
        <div className="sectionHeader">
          <div className="sectionNumber">1</div>
          <div>YOUR INFORMATION</div>
        </div>
        <div className="field">
          <div className="doubleField">
            <div>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                placeholder="First"
                className={`${
                  this.state.errors.guestFirstName ? 'error' : null
                }`}
                value={this.state.form.guestFirstName}
                onChange={(e) => this.updateFormState('guestFirstName', e)}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Last"
                className={`${
                  this.state.errors.guestLastName ? 'error' : null
                }`}
                value={this.state.form.guestLastName}
                onChange={(e) => this.updateFormState('guestLastName', e)}
              />
            </div>
          </div>
        </div>
        <div className="field">
          <label htmlFor="email">Email address</label>
          <p>Receipts and notifications will be sent to this address</p>
          <div className="singleField">
            <input
              type="text"
              placeholder="mail@example.com"
              className={`${this.state.errors.guestEmail ? 'error' : null}`}
              value={this.state.form.guestEmail}
              onChange={(e) => this.updateFormState('guestEmail', e)}
            />
          </div>
        </div>
        <div className="field">
          <label htmlFor="phone">Phone</label>
          <p>So we can contact you if necessary</p>
          <div className="singleField">
            <NumberFormat
              format="+1 (###) ###-####"
              placeholder="+1 (XXX) XXX-XXXX"
              mask="_"
              className={`${this.state.errors.guestPhone ? 'error' : null}`}
              value={this.state.form.guestPhone}
              onValueChange={(e) => this.updateFormState('guestPhone', e)}
            />
          </div>
        </div>
      </div>
    );
  };

  renderDeliverySelector = () => {
    const { deliveryChoice } = this.state;

    const checkmark = <i className="icon af-checkmark" />;

    return (
      <div className="field">
        <div className="selectorField">
          <div className="option" onClick={() => this.setDeliveryChoice('you')}>
            <div
              className={`selector ${
                deliveryChoice === 'you' ? 'selected' : null
              }`}
            >
              {deliveryChoice === 'you' ? checkmark : null}
            </div>
            <div className="label">You</div>
          </div>
          <div
            className="option"
            onClick={() => this.setDeliveryChoice('other')}
          >
            <div
              className={`selector ${
                deliveryChoice === 'other' ? 'selected' : null
              }`}
            >
              {deliveryChoice === 'other' ? checkmark : null}
            </div>
            <div className="label">Someone else</div>
          </div>
        </div>
      </div>
    );
  };

  renderDeliveryInformation = () => {
    const deliveryFields = (
      <div>
        <div className="field">
          <div className="doubleField">
            <div>
              <label htmlFor="name">Recipient's name</label>
              <input
                type="text"
                placeholder="First"
                className={`${
                  this.state.errors.recipientFirstName ? 'error' : null
                }`}
                value={this.state.form.recipientFirstName}
                onChange={(e) => this.updateFormState('recipientFirstName', e)}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Last"
                className={`${
                  this.state.errors.recipientLastName ? 'error' : null
                }`}
                value={this.state.form.recipientLastName}
                onChange={(e) => this.updateFormState('recipientLastName', e)}
              />
            </div>
          </div>
        </div>
        <div className="field">
          <label htmlFor="email">Recipient's email address</label>
          <div className="singleField">
            <input
              type="text"
              placeholder="mail@example.com"
              className={`${this.state.errors.recipientEmail ? 'error' : null}`}
              value={this.state.form.recipientEmail}
              onChange={(e) => this.updateFormState('recipientEmail', e)}
            />
          </div>
        </div>
        <div className="field">
          <label htmlFor="email">
            <div
              className="messageExpander"
              onClick={() =>
                this.setState({
                  recipientMessageExpanded:
                    !this.state.recipientMessageExpanded,
                })
              }
              dangerouslySetInnerHTML={{
                __html: this.state.recipientMessageExpanded
                  ? '&#8722;'
                  : '&#43;',
              }}
            />
            Message for Recipient (Optional)
          </label>
          <div
            className={`singleField ${
              this.state.recipientMessageExpanded ? '' : 'hidden'
            }`}
          >
            <textarea
              type="text"
              placeholder="Your message goes here."
              value={this.state.form.recipientMessage}
              onChange={(e) => this.updateFormState('recipientMessage', e)}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className="formSection">
        <div className="sectionHeader">
          <div className="sectionNumber">2</div>
          <div>DELIVERY INFORMATION</div>
        </div>
        {this.renderDeliverySelector()}
        {this.state.deliveryChoice === 'other' ? deliveryFields : null}
      </div>
    );
  };

  renderPaymentInformation = () => {
    return (
      <div className="formSection">
        <div className="sectionHeader">
          <div className="sectionNumber">3</div>
          <div>PAYMENT INFORMATION</div>
          <i className="icon af-lock brand-color" />
        </div>
        <div className="field">
          <p className="header">
            We do not store your credit card information. All payments are
            encrypted and securely processed through our PCI compliant provider.
          </p>
          <div className="doubleField">
            <div>
              <label htmlFor="name">Cardholders Name</label>
              <input
                type="text"
                placeholder="First"
                value={this.state.form.paymentFirstName}
                onChange={(e) => this.updateFormState('paymentFirstName', e)}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Last"
                value={this.state.form.paymentLastName}
                onChange={(e) => this.updateFormState('paymentLastName', e)}
              />
            </div>
          </div>
        </div>
        <div className="field">
          <label htmlFor="card-number">Card Number</label>
          <div className="singleField">
            <NumberFormat
              className={`creditCardInput ${this.determineCardType()}`}
              format="#### #### #### ####"
              value={this.state.form.paymentCardNumber}
              onValueChange={(e) =>
                this.updateFormState('paymentCardNumber', e)
              }
            />
          </div>
        </div>
        <div className="field">
          <div className="doubleField">
            <div>
              <label htmlFor="expiration-date">Expiration Date</label>
              <NumberFormat
                format="##/##"
                // eslint-disable-next-line no-undef
                placeholder={t('MM_YY')}
                mask={['M', 'M', 'Y', 'Y']}
                value={this.state.form.paymentExpirationDate}
                onValueChange={(e) =>
                  this.updateFormState('paymentExpirationDate', e)
                }
              />
            </div>
            <div>
              <label htmlFor="cvv">Security Code</label>
              <NumberFormat
                format="###"
                value={this.state.form.paymentSecurityCode}
                onValueChange={(e) =>
                  this.updateFormState('paymentSecurityCode', e)
                }
              />
            </div>
          </div>
        </div>
        <div className="field">
          <div className="doubleField">
            <div>
              <label htmlFor="country">Country</label>
              <ReactFlagsSelect defaultCountry="US" selectedSize={20} />
            </div>
            <div>
              <label htmlFor="zip">Zip</label>
              <NumberFormat
                format="#####"
                value={this.state.form.paymentZip}
                onValueChange={(e) => this.updateFormState('paymentZip', e)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="checkoutForm">
        <div className="heading">Checkout</div>
        <div className="formBody">
          <div className="left">
            {this.renderGuestDetails()}
            {this.renderDeliveryInformation()}
            {this.renderPaymentInformation()}
          </div>
          <div className="right">
            <Summary checkoutData={this.props.checkoutData} />
          </div>
        </div>
        <div
          data-testid="checkout-submit"
          className={`confirmButton ui fluid huge button anygreen ${
            this.state.submitLoading ? 'loading' : null
          }`}
          onClick={this.submitCheckout}
        >
          Confirm Purchase
        </div>
      </div>
    );
  }
}

export default Checkout;
